import { API } from "aws-amplify";
import { useEffect, useContext, useState } from "react";
import { ApiName, READ_ISSUE_DETAIL, RedminePath } from "../actions";
import AppContext from "../contexts/AppContext";

export const useIssueDetail = () => {
  const { state, dispatch } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [issueDetail, setIssueDetail] = useState({});
  const [redmineUrl, setRedmineUrl] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [errors, setErrors] = useState({});
  const [init, setInit] = useState(false);

  useEffect(() => {
    setRedmineUrl(state.current.redmineurl);
    setApiKey(state.current.apikey);
    setInit(true);
  }, [state.current]);

  useEffect(() => {
    setIssueDetail(state.issueDetail);
  }, [state.issueDetail]);

  const readissueDetail = async (conditions) => {
    try {
      if (loading !== true) setLoading(true);

      const id = conditions.id;
      if (apiKey !== "" && redmineUrl !== "") {
        const myInit = {
          headers: { "Content-type": "application/json", "X-Api-Key": apiKey },
          queryStringParameters: {
            path: `issues/${id}.json?include=journals,allowed_statuses`,
            url: redmineUrl,
          },
        };

        API.get(ApiName, RedminePath, myInit)
          .then((response) => {
            dispatch({ type: READ_ISSUE_DETAIL, response });
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
            setErrors({ api: err });
          });
        return "success";
      }
    } catch (err) {
      console.log("error");
      setErrors({ function: err });
    }
  };

  return {
    loading,
    setLoading,
    readissueDetail,
    issueDetail,
    errors,
    init,
  };
};
